module.exports = __webpack_public_path__ + "static/img/3.efdcd81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/eng/3.png
// module id = /GuR
// module chunks = 0